import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { IgxLegendComponent, IgxDataChartComponent, IgxCategoryXAxisComponent, IgxNumericYAxisComponent, IgxStackedColumnSeriesComponent, IgxStackedFragmentSeriesComponent, IgxDataToolTipLayerComponent } from 'igniteui-angular-charts';

@Component({
  selector: 'app-invoice-aging-test',
  templateUrl: './invoice-aging-test.component.html',
  styleUrl: './invoice-aging-test.component.scss',

})
export class InvoiceAgingTestComponent {
  
  @ViewChild("legend", { static: true } )
  private legend: IgxLegendComponent
  @ViewChild("chart", { static: true } )
  private chart: IgxDataChartComponent
  @ViewChild("xAxis", { static: true } )
  private xAxis: IgxCategoryXAxisComponent
  @ViewChild("yAxis", { static: true } )
  private yAxis: IgxNumericYAxisComponent
  @ViewChild("stackedColumnSeries", { static: true } )
  private stackedColumnSeries: IgxStackedColumnSeriesComponent
  @ViewChild("s1", { static: true } )
  private s1: IgxStackedFragmentSeriesComponent
  @ViewChild("s2", { static: true } )
  private s2: IgxStackedFragmentSeriesComponent
  @ViewChild("s3", { static: true } )
  private s3: IgxStackedFragmentSeriesComponent
  @ViewChild("s4", { static: true } )
  private s4: IgxStackedFragmentSeriesComponent
  @ViewChild("s5", { static: true } )
  private s5: IgxStackedFragmentSeriesComponent
  @ViewChild("dataToolTipLayer", { static: true } )
  private dataToolTipLayer: IgxDataToolTipLayerComponent
  private _continentsBirthRate: ContinentsBirthRate = null;
  public get continentsBirthRate(): ContinentsBirthRate {
      if (this._continentsBirthRate == null)
      {
          this._continentsBirthRate = new ContinentsBirthRate();
      }
      return this._continentsBirthRate;
  }

  public constructor(private _detector: ChangeDetectorRef)
  {
  }

  public ngAfterViewInit(): void
  {
  }
}


export class ContinentsBirthRateItem {
  public constructor(init: Partial<ContinentsBirthRateItem>) {
      Object.assign(this, init);
  }

  public year: string;
  public asia: number;
  public africa: number;
  public europe: number;
  public northAmerica: number;
  public southAmerica: number;
  public oceania: number;

}
export class ContinentsBirthRate extends Array<ContinentsBirthRateItem> {
  public constructor(items: Array<ContinentsBirthRateItem> | number = -1) {
      if (Array.isArray(items)) {
          super(...items);
      } else {
          const newItems = [
              new ContinentsBirthRateItem(
              {
                  year: `1950`,
                  asia: 62,
                  africa: 13,
                  europe: 10,
                  northAmerica: 4,
                  southAmerica: 8,
                  oceania: 1
              }),
              new ContinentsBirthRateItem(
              {
                  year: `1960`,
                  asia: 68,
                  africa: 12,
                  europe: 15,
                  northAmerica: 4,
                  southAmerica: 9,
                  oceania: 2
              }),
              new ContinentsBirthRateItem(
              {
                  year: `1970`,
                  asia: 80,
                  africa: 17,
                  europe: 11,
                  northAmerica: 3,
                  southAmerica: 9,
                  oceania: 1
              }),
              new ContinentsBirthRateItem(
              {
                  year: `1980`,
                  asia: 77,
                  africa: 21,
                  europe: 12,
                  northAmerica: 3,
                  southAmerica: 10,
                  oceania: 2
              }),
              new ContinentsBirthRateItem(
              {
                  year: `1990`,
                  asia: 87,
                  africa: 24,
                  europe: 9,
                  northAmerica: 3,
                  southAmerica: 10,
                  oceania: 1
              }),
              new ContinentsBirthRateItem(
              {
                  year: `2000`,
                  asia: 79,
                  africa: 28,
                  europe: 8,
                  northAmerica: 4,
                  southAmerica: 9,
                  oceania: 3
              }),
              new ContinentsBirthRateItem(
              {
                  year: `2010`,
                  asia: 78,
                  africa: 35,
                  europe: 10,
                  northAmerica: 4,
                  southAmerica: 8,
                  oceania: 2
              }),
              new ContinentsBirthRateItem(
              {
                  year: `2020`,
                  asia: 75,
                  africa: 43,
                  europe: 7,
                  northAmerica: 4,
                  southAmerica: 7,
                  oceania: 4
              }),
          ];
          super(...(newItems.slice(0, items)));
      }
  }
}